<template>
    <footer>
        <div class="text-right">
            <p>
                <span>
                    <a :href="subscriberAgreement.link" target="_blank">Termos de uso e contrato</a>
                </span>
                <span>© {{currentYear}} C2B Software</span>
            </p>
        </div>
    </footer>
</template>

<script>
import { mapState } from 'vuex';
import { SubscriberAgreementModel } from '../../subscriber/models/SubscriberAgreementModel'
import subscriberService from '@/subscriber/services/SubscriberService'

export default {
    name: 'FooterCmp',
    data() {
        return {
            subscriberAgreement: new SubscriberAgreementModel(),
            currentYear: new Date().getFullYear(),
        }
    },
    async mounted() {
        this.subscriberAgreement = await subscriberService.getAgreement()
    },
    computed: {
        ...mapState({
            subscriber: state => state.subscriber,
        }),
    },
}
</script>

<style lang="scss" scoped>
footer {
    display: none;

    @media (min-width: 992px) {
        clear: both;
        float: right;
        display: block;
        font-size: .8em;
        font-family: monospace;
        color: var(--text-muted);
        padding: 50px 20px 0 0;        
        
        p {
            span {
                &:not(:last-of-type) {
                    margin-right: 15px;
                }

                a {
                    color: var(--text-muted);
                    text-decoration: none;

                    &:hover {
                        border-bottom: 1px dashed var(--border-strong);
                    }
                }
            }
        }
    }    
}
</style>
